import {API_URL} from "../Config/config";
import { AuthService } from "./AuthService";
import {DateToUnixTimestamp} from "../Utils/DateHelper";

export class ModuliService {

    /**
   * Returns elements
   *
   * @param filter
   * @param paginate
   * @returns {Promise<any>}
   */
  getModuli = (paginate,filters) => {
      let url = `${API_URL}modulo/read.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      if(paginate){
        if(typeof paginate.first !== "undefined"){
          url += `&p_offset=${paginate.first}`;
        }
        if(typeof paginate.size !== "undefined"){
          url += `&p_size=${paginate.size}`;
        }
        if(typeof paginate.multiSortMeta !== "undefined"){
          url += `&p_sort=${JSON.stringify(paginate.multiSortMeta)}`;
        }
      }
      if(filters){
        url += `&filters=${JSON.stringify(filters)}`;
      }
      const requestOptions = {
          method: "GET",
          headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`}
      };
      return fetch(url, requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else{
          return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
      });
  }

  getModulo = (idmodulo) => {
    let url = `${API_URL}modulo/single_read.php?timestamp=${DateToUnixTimestamp(new Date())}`;
    if(idmodulo){
      url += `&idmodulo=${idmodulo}`;
    }
    const requestOptions = {
        method: "GET",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`}
    };
    return fetch(url,requestOptions).then(response => {
      if(response && response.status===200){
        return response.json();
      }
      else{
        return {isOk: false, data: [], errorMessage: "error.generic"};
      }
    }).catch(error => {
      return {isOk: false, data: [], errorMessage: "error.generic"};
    });
  }

  deleteModulo = (idmodulo) => {
      let url = `${API_URL}modulo/delete.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      const requestOptions = {
        method: "DELETE",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`},
        body: JSON.stringify({idmodulo: idmodulo})
      };
      return fetch(url,requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else {
          return {isOk: false, errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, errorMessage: "error.generic"};
      });
  }

  createCorso = (corso) => {
      let url = `${API_URL}corso/create.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      const requestOptions = {
        method: "POST",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`},
        body: JSON.stringify(corso)
      };
      return fetch(url,requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else {
          return {isOk: false, errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
      });
  }

  updateModulo = (modulo) => {
      let url = `${API_URL}modulo/update.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      const requestOptions = {
        method: "POST",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`},
        body: JSON.stringify(modulo)
      };
      return fetch(url,requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else {
          return {isOk: false, errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
      });
  }

}
